import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Route, Switch, useLocation } from "react-router-dom";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import Group from "components/Group/Group";
import routes from "routes.js";
import ProjectProgress from "components/Project/projectprogress";
import NotAuth from "components/NotAuth/NotAuth";
import IndProjectProgress from "components/Project/indprojectprog";
import groupProjectProgress from "components/Project/groupprojectprog";
import StudentDashboard from '../views/capstone/Dashboard';
import CourseGrading from "components/Course/grading";
import ProgressReport from "views/ProgressReport";
//import IvyAIChatBot from "components/bot/ai"
var ps;

function AdminLayout() {
  const location = useLocation();
  const mainPanel = React.useRef();
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
  }, [location]);


  return (
    
    <div className="wrapper">
      <Sidebar routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <DemoNavbar />
        <Switch>
          {routes.map((prop, key) => {
            return (
              <Route
                exact path={prop.path}
                component={prop.component}
                key={key}
              />
            );
          })}
          <Route exact path="/groups/:id" component={Group}/>
          <Route exact path="/projects/:id" component={IndProjectProgress} />
          <Route exact path="/groupprojects/:id" component={groupProjectProgress} />
          <Route exact path="/groups/:id/p/:proid" component={ProjectProgress}/>
          <Route exact path="/course/:id" component={CourseGrading}/>
          <Route exact path="/progress-report" component={ProgressReport}/>
          <Route path="/StudentDashboard" component={StudentDashboard}/>

          <Route exact path="/no-auth" component={NotAuth}/>
        </Switch>
{/*          <IvyAIChatBot/>
 */}      </div>
     
    </div>
  );
}

export default AdminLayout;
